import { ArrowUpLeft, ArrowUpRight } from '~/svgs/navbar';
import { NextLink, Translate, useTranslate } from '~/i18n';
import {
   experienceBookNowDataLayer,
   // experienceGetDirectionstDataLayer,
} from '~/analytics/gtm/events';
import Container from '../common/container';
import OfflineExperienceModal from './offline-experience';
import cn from 'classnames';
import { formatNumber } from '~/utils/format-price';
import { useCurrency } from '~/providers';
import { useRouter } from 'next/router';
import { useState } from 'react';
import {
   BirthdayCakeIcon,
   ClockOutlineIcon,
   GroupIcon,
   // HelpOutlineIcon,
   LocationOutlineIcon,
   TicketIcon,
   // MarkerMap,
   MapOutlineIcon,
   RateSmallIcon,
   OfferBadgeIcon,
} from '~/svgs/common';
// import dynamic from 'next/dynamic';
import Button from '../common/button';

// const GoogleMap = dynamic(() => import('google-map-react'), {
//    ssr: false,
//    loading() {
//       return (
//          <div className="text-gray-500">
//             <Translate id="common:loading" />
//          </div>
//       );
//    },
// });

// const Marker: React.FC<any> = () => {
//    return (
//       <div className="relative">
//          <div className="absolute inset-0">
//             <MarkerMap />
//          </div>
//       </div>
//    );
// };

interface BookingDetailsCTAProps {
   price: number;
   discounted_price?: number;
   is_external?: boolean;
   venue_type: string;
   external_link?: string;
   is_dmc?: boolean;
   share_description?: string;
   share_title?: string;
   book_online?: boolean;
   id: string;
   gender: string[];
   venue_type_details?: any;
   city: string;
   price_start_from?: string;
   booking_closed?: boolean | any;
   is_tabby?: boolean;
   is_tamara?: boolean;
   min_participants: number;
   duration: string;
   age_from: number;
   age_to: number;
   lat: number;
   lng: number;
   reviews?: {
      curr_page: number;
      experience_rating: number;
      last_page: number;
      organizer_rating: number;
      overall_rating: number;
      reviews: any[];
      total: number;
      venue_rating: number;
      price_rating: number;
   };
   tags: any[];
   category: Record<string, any>;
}

const getDiscount = (price: number, discounted_price: number) => {
   if (price > 0) {
      const amount = (1 - discounted_price / price) * 100;
      return formatNumber(amount);
   }
   return '';
};

export const BookingDetailsCTA = ({
   price,
   discounted_price,
   venue_type,
   is_external,
   external_link,
   share_title,
   book_online,
   city,
   id,
   price_start_from,
   booking_closed,
   is_tabby,
   is_tamara,
   min_participants,
   duration,
   age_from,
   age_to,
   lat,
   lng,
   reviews,
   tags,
   category,
}: // venue_type_details,
BookingDetailsCTAProps) => {
   const { dir, translate } = useTranslate();
   const [offlineModal, setOfflineModal] = useState(false);
   const router = useRouter();
   const isPrivate = router.pathname.includes('private');
   const { getConvertedPriceWithSymbol } = useCurrency();
   const [loading, setLoading] = useState(false);
   const isFree = !price && !discounted_price && !price_start_from;

   const informationList = [
      {
         key: 'location',
         title: translate({ id: 'filters:destination' }),
         value: city,
         icon: <LocationOutlineIcon />,
      },
      {
         key: 'duraion',
         title: translate({ id: 'common:duration' }),
         value: duration,
         icon: <ClockOutlineIcon />,
      },
      {
         key: 'age',
         title: translate({ id: 'common:ages' }),
         value:
            Number(age_to) > 80
               ? `${translate({ id: 'common:all ages' })}`
               : `${translate({ id: 'common:above' })} ${age_from}`,
         icon: <BirthdayCakeIcon />,
      },
      // {
      //    key: 'type',
      //    title: translate({ id: 'common:type' }),
      //    value: venue_type,
      //    icon: <GroupIcon />,
      // },
      // {
      //    key: 'language',
      //    title: translate({ id: 'common:language' }),
      //    value: 'Arabic & English',
      //    icon: <LanguagesIcon />,
      // },
   ];

   const analytics_params = {
      event_location: city,
      package_name: share_title || '',
      package_price: String(discounted_price || price),
   };

   const bookHandler = () => {
      experienceBookNowDataLayer(analytics_params);
      // const isOnline = router.query.category === 'online';
      if (venue_type === 'offline_experience') {
         setOfflineModal(true);
         return;
      }
      if (is_external && external_link) return window.open(external_link, '_blank');
      else {
         setLoading(true);
         const { query } = router;
         const { lang, city, category, slug } = query;
         router.push(`/${lang}/experiences/${city}/${category}/${slug}/book`);
      }
   };

   const tagLink = (label: string, slug: string, type: 'tag' | 'category') => (
      <NextLink
         className="px-4 py-1 border border-[#a5a5a5] rounded-full text-center w-fit capitalize hover:bg-madinah-primary hover:text-white"
         href={type === 'category' ? `/search` : `/search?query=${slug}`}>
         {label}
      </NextLink>
   );

   const getButton = () => (
      <Button
         id="see-dates"
         type="primary"
         onClick={bookHandler}
         className={cn(
            'w-full',
            (!book_online || isPrivate || (booking_closed && !is_external) || loading) &&
               'bg-opacity-75 border-opacity-75 hover:opacity-100 cursor-not-allowed'
         )}
         disabled={!book_online || isPrivate || (booking_closed && !is_external) || loading}>
         <div className="flex items-center justify-center gap-3 pointer-events-none">
            <TicketIcon />
            <span className="font-semibold">
               {booking_closed && !is_external ? (
                  <Translate id="booking:sold out" />
               ) : book_online ? (
                  <div className="pointer-events-none">
                     {venue_type === 'offline_experience' ? (
                        <Translate id="booking:notify me" />
                     ) : (
                        <Translate id="booking:book online" />
                     )}
                  </div>
               ) : (
                  <Translate id="booking:book unavailable" />
               )}
            </span>
            {is_external && (
               <div className="pointer-events-none">
                  {dir === 'ltr' ? (
                     <ArrowUpRight className="ml-4 transform scale-150" />
                  ) : (
                     <ArrowUpLeft className="mr-4 transform scale-150" />
                  )}
               </div>
            )}
         </div>
      </Button>
   );

   return (
      <div className="top-0 px-4 lg:px-0 w-full lg:w-[31%] lg:ltr:pl-0 lg:rtl:pr-0 relative">
         {venue_type === 'offline_experience' && (
            <OfflineExperienceModal
               venue_id={id}
               open={offlineModal}
               onClose={() => setOfflineModal(false)}
            />
         )}
         <div
            className="fixed inset-x-0 bottom-0 z-30 py-4 bg-white md:hidden"
            style={{ boxShadow: '0 -1px 7px 0 rgba(33,37,41,0.2)' }}>
            <Container>
               <div className="flex items-center justify-between">
                  <div>
                     <div className="font-medium text-gray-600">
                        <Translate id="common:starts from" />
                     </div>
                     {price_start_from ? (
                        <p className="text-lg font-bold">{price_start_from}</p>
                     ) : (
                        <>
                           <span className="text-lg font-bold">
                              {getConvertedPriceWithSymbol(discounted_price || price)}
                           </span>
                           <div>
                              {discounted_price && discounted_price < price ? (
                                 <span className="flex items-center">
                                    <span className="text-gray-500 line-through">
                                       <span className="hidden">
                                          <Translate id="common:price before discount" />
                                       </span>
                                       {getConvertedPriceWithSymbol(price)}
                                    </span>
                                    <span className="text-sm py-0.5 px-1 rounded text-primary-green bg-green-100 last:mr-0 ltr:ml-2 rtl:mr-2">
                                       <span className="hidden">
                                          <Translate id="common:discount percentage" />
                                       </span>
                                       <Translate
                                          id="common:discount"
                                          values={{
                                             amount: getDiscount(price, discounted_price),
                                          }}
                                       />
                                    </span>
                                 </span>
                              ) : null}
                           </div>
                        </>
                     )}
                  </div>
                  <div>{getButton()}</div>
               </div>
            </Container>
         </div>

         <div className="hidden md:block pb-4 overflow-hidden mb-12 rounded-xl bg-white shadow-vs border border-black/20 backdrop-blur-[3px] top-40">
            {/* <div
               className="h-12 bg-madinah-primary"
               style={{ backgroundImage: "url('/sta/cta-border-art.png')" }}
            /> */}
            <div className="flex flex-col items-center justify-center gap-2 px-4 py-4">
               {price_start_from ? (
                  <p className="text-2xl font-bold">
                     {price_start_from}{' '}
                     <span className="text-sm font-normal">
                        / <Translate id="common:per person" />
                     </span>
                  </p>
               ) : (
                  <span className="text-2xl font-bold">
                     {getConvertedPriceWithSymbol((discounted_price || price) ?? 0)}{' '}
                     <span className="relative text-sm font-normal -top-1">
                        / <Translate id="common:per person" />
                     </span>
                  </span>
               )}
               <span>
                  <Translate
                     id="common:minimum number of people"
                     values={{ count: min_participants }}
                  />
               </span>

               {!price_start_from && discounted_price && discounted_price < price ? (
                  <span className="flex items-center gap-3 my-2">
                     <span className="text-lg font-medium line-through ltr:ml-2 rtl:mr-2">
                        {getConvertedPriceWithSymbol(Number(price))}
                     </span>
                     <span className="flex items-center gap-3 px-2 py-1 text-sm bg-opacity-25 rounded-lg text-primary-success bg-primary-success last:mr-0 ltr:ml-2 rtl:mr-2">
                        <OfferBadgeIcon />
                        <span className="font-bold uppercase">
                           <Translate
                              id="common:discount"
                              values={{
                                 amount: getDiscount(price, discounted_price),
                              }}
                           />
                        </span>
                     </span>
                  </span>
               ) : (
                  ''
               )}
            </div>

            <div className="px-4">
               {!isFree && is_tabby ? (
                  <div className="mb-3">
                     {/* <TabbyWidget price={price_start_from || discounted_price || price} /> */}
                  </div>
               ) : null}

               {!isFree && is_tamara ? (
                  <div className="mb-3">
                     {/* <TamaraWidgetV2 price={price_start_from || discounted_price || price} /> */}
                  </div>
               ) : null}

               {getButton()}

               {/* {getBookingType()} */}
            </div>
         </div>
         {reviews?.total && reviews?.total > 0 ? (
            <div className="pb-4 mb-12 overflow-hidden bg-white shadow-vs border border-black/20 backdrop-blur-[3px] top-40 rounded-default">
               {/* <div
                  className="h-12"
                  // style={{ backgroundImage: "url('/sta/cta-gray-border-art.png')" }}
               /> */}
               <h4 className="px-4 pt-4 pb-2 text-sm font-bold uppercase">
                  <Translate id="review:rating & reviews" />
               </h4>
               <div className="flex items-center gap-3 px-4">
                  <GroupIcon className="[&>*]:fill-madinah-primary w-8 h-8" />
                  <div className="flex">
                     {[...new Array(5)].map((_, idx) => (
                        <RateSmallIcon
                           key={idx}
                           className="w-5 h-5"
                           style={{
                              color: Math.ceil(reviews?.total) >= idx + 1 ? '#FFB800' : '#CED4DA',
                           }}
                        />
                     ))}
                  </div>
                  <div className="mt-1 text-lg">
                     <span className="px-3 border-r border-black">
                        {formatNumber(reviews.overall_rating, 1)}
                     </span>
                     <span className="px-3 lowercase text-madinah-primary">
                        {reviews.total} <Translate id="common:reviews" />
                     </span>
                  </div>
               </div>
            </div>
         ) : null}

         <div className="pb-4 mb-12 overflow-hidden bg-white top-40 rounded-xl  shadow-vs border border-black/20 backdrop-blur-[3px]">
            {/* <div
               className="h-12"
               style={{ backgroundImage: "url('/sta/cta-gray-border-art.png')" }}
            /> */}
            <h4 className="px-4 pt-4 pb-2 text-sm font-bold uppercase">
               <Translate id="common:information" />
            </h4>
            <div className="flex flex-col gap-2 px-4">
               {informationList?.map(item => (
                  <div key={item.key} className="flex items-center justify-between">
                     <div className="flex items-center gap-2">
                        {item.icon}
                        <span>{item.title}:</span>
                     </div>
                     <span className="font-bold">{item.value}</span>
                  </div>
               ))}
            </div>
            <h4 className="px-4 pt-4 pb-2 text-sm font-bold uppercase">
               <Translate id="common:related keywords" />
            </h4>
            <div className="flex flex-wrap items-center gap-3 px-4">
               {tagLink(category?.title, category?.slug, 'category')}
               {tags?.length ? tags?.map(tag => tagLink(tag, tag, 'tag')) : null}
            </div>
         </div>

         <div className="pb-4 mb-12 overflow-hidden rounded-xl bg-white shadow-vs border border-black/20 backdrop-blur-[3px] top-40 ">
            <h4 className="px-4 pt-4 pb-2 text-sm font-bold uppercase">
               <Translate id="booking:meeting point" />
            </h4>
            <div className="flex flex-col gap-2 px-4">
               <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2">
                     <LocationOutlineIcon />
                     <span className="">
                        <Translate id="common:location" />: {city}
                     </span>
                  </div>
               </div>
            </div>
            {lat && lng ? (
               <div>
                  {/* <div className="w-full h-48 my-4 overflow-hidden rounded cursor-pointer">
                     <a
                        // onClick={() =>
                        //    experienceGetDirectionstDataLayer({
                        //       event_location: city,
                        //       package_name: share_title || '',
                        //       package_price: String(discounted_price || price),
                        //    })
                        // }
                        rel="noopener noreferrer"
                        target="_blank"
                        href={`https://maps.google.com/?q=${lat},${lng}&z=8`}
                        className="cursor-pointer d-block text-gray-700-color">
                        <GoogleMap
                           defaultCenter={{ lat, lng }}
                           defaultZoom={13}
                           bootstrapURLKeys={{
                              key: process.env.NEXT_PUBLIC_GOOGLE_MAP + '',
                           }}
                           options={{ disableDefaultUI: true, draggable: false }}>
                           <Marker lat={lat} lng={lng} />
                        </GoogleMap>
                     </a>
                  </div> */}
                  <div className="p-4">
                     <Button
                        onClick={() => {
                           window.open(`https://maps.google.com/?q=${lat},${lng}&z=8`, '_blank');
                           // experienceGetDirectionstDataLayer({
                           //    event_location: city,
                           //    package_name: share_title || '',
                           //    package_price: String(discounted_price || price),
                           // });
                        }}
                        className="flex items-center justify-center w-full gap-3 rounded-lg h-11">
                        <MapOutlineIcon />{' '}
                        <span className="font-semibold">
                           <Translate id="booking:get directions" />
                        </span>
                     </Button>
                  </div>
               </div>
            ) : null}
         </div>

         {/* <div className="pb-4 mb-12 overflow-hidden bg-white top-40 rounded-default">
            <div
               className="h-12"
               style={{ backgroundImage: "url('/sta/cta-gray-border-art.png')" }}
            />
            <h4 className="px-4 pt-4 text-sm font-bold uppercase">
               <Translate id="common:do you need help" />
            </h4>
            <p className="px-4 pt-3 pb-4">
               <Translate id="common:need help description" />
            </p>
            <div className="px-4">
               <a
                  href={`https://www.visitsaudi.com/${locale}/help-support`}
                  rel="noreferrer noopener"
                  target="_blank">
                  <Button className="flex items-center justify-center w-full gap-3 h-11">
                     <HelpOutlineIcon />{' '}
                     <span className="font-semibold">
                        <Translate id="common:get more help" />
                     </span>
                  </Button>
               </a>
            </div>
         </div> */}
      </div>
   );
};
